import { motion } from 'motion/react';
import { Shield, Lock } from 'lucide-react';

export default function GlobalFooter() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 px-8 py-4"
      style={{
        background: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(40px)',
      }}
    >
      <div className="flex items-center justify-between">
        {/* Left: Security Badge */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <Shield className="h-3.5 w-3.5" style={{ color: '#4AE290' }} />
            <span 
              className="uppercase"
              style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '10px',
                fontWeight: 400,
                letterSpacing: '0.08em',
                color: '#4AE290',
              }}
            >
              [ E2E ENCRYPTED ]
            </span>
          </div>
          
          <div 
            className="h-4 w-px"
            style={{ background: 'rgba(255, 255, 255, 0.15)' }}
          />
          
          <div className="flex items-center gap-2">
            <Lock className="h-3.5 w-3.5" style={{ color: '#888888' }} />
            <span 
              className="uppercase"
              style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '10px',
                fontWeight: 400,
                letterSpacing: '0.08em',
                color: '#888888',
              }}
            >
              Zero-Knowledge Architecture
            </span>
          </div>
        </div>

        {/* Right: Legal & Support Links */}
        <div className="flex items-center gap-6">
          <button 
            className="transition-opacity duration-200 hover:opacity-70"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '11px',
              fontWeight: 400,
              color: '#888888',
            }}
          >
            Privacy Policy
          </button>
          
          <button 
            className="transition-opacity duration-200 hover:opacity-70"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '11px',
              fontWeight: 400,
              color: '#888888',
            }}
          >
            Terms of Service
          </button>
          
          <div 
            className="h-4 w-px"
            style={{ background: 'rgba(255, 255, 255, 0.15)' }}
          />
          
          <span 
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '11px',
              fontWeight: 400,
              color: '#666666',
            }}
          >
            © 2026 Bluepinksecurity INC
          </span>
        </div>
      </div>
    </motion.div>
  );
}
